define('src/views/click-outside-view',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils'
], function(_, Backbone, Mustache, U) {

    var $body = Backbone.$(document.body);
    /**
     * Backbone view mixin that enables the view to catch simulated
     * "click:outside" events by tracking the mouse and focusing the
     * element.
     *
     * Additional information: Since the blur event is triggered on a mouse
     * button pressed and the click is triggered on mouse button released, the
     * blur callback gets called first which then listen for click event on the
     * body to trigger the simulated outside click.
     */
    var VClickOutside = Backbone.Epoxy.View.extend({
        events: {
            "mouseleave": "_onMouseLeave",
            "mouseenter": "_onMouseEnter",
            "blur": "_onBlur",
        },
        /**
         * Overwrite the default constructor to extends events.
         */
        constructor: function() {
            var proto = VClickOutside.prototype;
            _.extend(this, {
                events: _.extend({}, proto.events, this.events),
                mouseInside: false
            });

            VClickOutside.__super__.constructor.apply(this, arguments);
            this._bodyEventName = 'click.once' + this.cid;
        },

        /**
         * Hijack this private method to ensure the element has
         * the tabindex attribute and is ready to be used.
         */
        _setElement: function(el) {
            VClickOutside.__super__._setElement.apply(this, arguments);

            var focusEl = this.focusEl;

            if (focusEl && !this.$focusElem) {
                this.$focusElem = focusEl;
                if (!(focusEl instanceof Backbone.$)) {
                    this.$focusElem = Backbone.$(focusEl);
                }
            } else {
                this.$focusElem = this.$el;
            }
            this.$focusElem.attr('tabindex', -1);
        },

        focus: function() {
            this.$focusElem.focus();
        },

        unfocus: function() {
            this.$focusElem.blur();
            $body.off(this._bodyEventName);
        },

        isMouseInside: function() {
            return this.mouseInside;
        },

        ////////////////////////////
        // private Event handlers //
        ////////////////////////////
        onClickOutside: _.noop,
        _onClickOutside: function(e) {
            this.onClickOutside(e);
            this.$focusElem.trigger("click:outside", e);
        },

        _onBlur: function(e) {
            var $focusElem = this.$focusElem;
            if (!this.isMouseInside() && $focusElem.is(':visible')) {
                $body.one(this._bodyEventName, this._onClickOutside.bind(this));
            } else {
                $focusElem.focus(); // refocus on inside click
            }
        },

        _onMouseEnter: function(e) {
            this.mouseInside = true;
        },
        _onMouseLeave: function(e) {
            this.mouseInside = false;
        },

    });

    return VClickOutside;

});

